module.exports = __webpack_public_path__ + "img/Mindy_Elena-600h.f9c4629d.webp";